import React from 'react';
import ReactDOM from 'react-dom';

import Typo from './react/components/Typo/Typo.jsx';

const reactEl = document.createElement('div');
document.body.appendChild(reactEl);

ReactDOM.render(<Typo />, reactEl);
